var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatwedoArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 88,
    viewBox: "0 0 86 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3349 80.7932L85.8608 65.3226L70.3786 20.8007L61.346 23.9399L71.857 54.1616L5.72221 20.0053L1.89074 27.4239L67.968 61.5506L38.2372 71.8799L41.3349 80.7932Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatwedoArrowWhite);
export default __webpack_public_path__ + "static/media/whatwedoArrowWhite.db4c07d4ade639142febf77b307ea031.svg";
export { ForwardRef as ReactComponent };